webpackJsonp([105484401514700],{

/***/ 233:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/specialities.d0fb.jpg";

/***/ }),

/***/ 121:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Chicken = function Chicken(props) {
	  return _react2.default.createElement(
	    "svg",
	    _extends({ viewBox: "0 0 100 100" }, props),
	    _react2.default.createElement(
	      "g",
	      { fill: "none", opacity: 0.4 },
	      _react2.default.createElement("circle", { fillOpacity: 0.8, fill: "#4A4A4A", cx: 50, cy: 50, r: 50 }),
	      _react2.default.createElement("path", {
	        d: "M75.826 37.135L16.092 69.849l30.005 30c1.288.1 2.59.151 3.903.151 24.1 0 44.215-17.05 48.946-39.745l-23.12-23.12z",
	        fill: "#4A4A4A"
	      }),
	      _react2.default.createElement("path", {
	        d: "M22.055 53.569c0 12.56 18.383 16.245 36.551 16.245 18.168 0 21.93-6.934 21.93-19.494 0-12.56-7.417-19.494-25.585-19.494S22.055 41.008 22.055 53.569z",
	        fill: "#682421"
	      }),
	      _react2.default.createElement("path", {
	        d: "M17.688 31.278l7.345 5.354 1.785-2.448-7.345-5.354a3.03 3.03 0 1 0-5.46-2.105 3.03 3.03 0 1 0 3.674 4.553z",
	        fill: "#F0DEB4"
	      }),
	      _react2.default.createElement("path", {
	        d: "M54.95 30.826c-1.526 0-3.029.074-4.5.213v38.506c2.68.185 5.42.269 8.156.269 18.168 0 21.93-6.934 21.93-19.494 0-12.56-7.417-19.494-25.585-19.494z",
	        fill: "#5B1D1D"
	      }),
	      _react2.default.createElement("path", {
	        d: "M43.521 36.987c4.057 2.956 2.75 6.88-.208 10.937-2.957 4.056-6.445 6.71-10.502 3.753-4.056-2.956-12.292-13.997-9.334-18.053 2.957-4.057 15.988.405 20.044 3.363z",
	        fill: "#823733"
	      }),
	      _react2.default.createElement("path", {
	        d: "M66.36 60.486c0-3.589 3.437-5.513 7.679-5.513 4.24 0 7.68 1.924 7.68 5.513 0 3.59-3.439 6.498-7.68 6.498-4.242 0-7.68-2.909-7.68-6.498zm-44.305 0c0-3.589 3.438-5.513 7.68-5.513 4.24 0 7.679 1.924 7.679 5.513 0 3.59-3.438 6.498-7.68 6.498-4.241 0-7.68-2.909-7.68-6.498z",
	        fill: "#C0392B"
	      }),
	      _react2.default.createElement("circle", { fill: "#6AAC4B", cx: 63.209, cy: 62.652, r: 1.772 }),
	      _react2.default.createElement("circle", { fill: "#6AAC4B", cx: 56.317, cy: 62.652, r: 1.772 }),
	      _react2.default.createElement("circle", { fill: "#59913C", cx: 59.27, cy: 62.652, r: 1.772 }),
	      _react2.default.createElement("path", {
	        d: "M18.412 70.824h64.783a3.249 3.249 0 1 0 0-6.498H18.412a3.249 3.249 0 1 0 0 6.498z",
	        fill: "#F0DEB4"
	      }),
	      _react2.default.createElement("path", {
	        d: "M83.195 64.326H50.449v6.498h32.746a3.25 3.25 0 1 0 0-6.498z",
	        fill: "#D6C299"
	      })
	    )
	  );
	};
	
	exports.default = Chicken;
	module.exports = exports["default"];

/***/ }),

/***/ 125:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Cupcake = function Cupcake(props) {
	  return _react2.default.createElement(
	    "svg",
	    _extends({ viewBox: "0 0 100 100" }, props),
	    _react2.default.createElement(
	      "g",
	      { fill: "none", opacity: 0.4 },
	      _react2.default.createElement("circle", { fillOpacity: 0.8, fill: "#4A4A4A", cx: 50, cy: 50, r: 50 }),
	      _react2.default.createElement("path", {
	        d: "M70.074 32.08L33.06 75.754l23.778 23.777C77.633 96.688 94.354 81.06 98.82 60.827L70.074 32.079z",
	        fill: "#4A4A4A"
	      }),
	      _react2.default.createElement("path", {
	        d: "M73.906 49.808l-6.062 24.247a4.058 4.058 0 0 1-3.936 3.074H36.092a4.057 4.057 0 0 1-3.936-3.074l-6.062-24.247h47.812z",
	        fill: "#EF717A"
	      }),
	      _react2.default.createElement("path", {
	        d: "M23.4 47.657c0-13.118 11.91-23.751 26.6-23.751 14.69 0 26.6 10.633 26.6 23.75 0 13.118-11.91 5.939-26.6 5.939-14.69 0-26.6 7.18-26.6-5.938z",
	        fill: "#F0DEB4"
	      }),
	      _react2.default.createElement("path", {
	        d: "M50 23.906c-14.602 0-26.45 10.507-26.593 23.516 2.399 1.123 4.96 1.76 7.401 1.905 14.141.336 28.283 0 43.098-2.694a8.96 8.96 0 0 0 2.59-1.003C75.343 33.462 63.925 23.906 50 23.906z",
	        fill: "#D5C295"
	      }),
	      _react2.default.createElement("circle", { fill: "#C63C22", cx: 50, cy: 22.222, r: 5.556 }),
	      _react2.default.createElement("path", {
	        d: "M49.888 49.808v27.32h14.02a4.057 4.057 0 0 0 3.936-3.073l6.062-24.247H49.888z",
	        fill: "#D95459"
	      }),
	      _react2.default.createElement("path", {
	        d: "M50 23.906l-.112.002v29.688l.112-.001c14.69 0 26.6 7.18 26.6-5.938 0-13.118-11.91-23.751-26.6-23.751z",
	        fill: "#D8C49A"
	      }),
	      _react2.default.createElement("path", {
	        d: "M76.496 45.63C75.343 33.462 63.925 23.906 50 23.906l-.112.002V49.22c7.876-.334 15.844-1.1 24.018-2.586a8.96 8.96 0 0 0 2.59-1.003z",
	        fill: "#BAA479"
	      }),
	      _react2.default.createElement("path", {
	        d: "M50 16.667c-.038 0-.074.005-.112.005v11.1c.038 0 .074.006.112.006a5.555 5.555 0 1 0 0-11.111z",
	        fill: "#A52923"
	      })
	    )
	  );
	};
	
	exports.default = Cupcake;
	module.exports = exports["default"];

/***/ }),

/***/ 127:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Fish = function Fish(props) {
	  return _react2.default.createElement(
	    "svg",
	    _extends({ viewBox: "0 0 100 100" }, props),
	    _react2.default.createElement(
	      "g",
	      { fill: "none" },
	      _react2.default.createElement("circle", { fillOpacity: 0.8, fill: "#4A4A4A", cx: 50, cy: 50, r: 50 }),
	      _react2.default.createElement("path", {
	        d: "M50.997 99.987c24.793-.485 45.16-19.015 48.515-43L85.126 42.6 44.867 61.55 23.344 40.029l-5.19 20.592-6.76-.236 39.603 39.603z",
	        fill: "#4A4A4A"
	      }),
	      _react2.default.createElement("path", {
	        d: "M61.736 35.417c-13.1 0-28.122 3.293-35.73 8.087-1.833-3.562-5.125-5.939-8.884-5.939-2.117 0-4.085.756-5.729 2.051 2.824 2.224 4.688 6.043 4.688 10.384 0 4.34-1.864 8.16-4.688 10.384 1.644 1.295 3.612 2.05 5.73 2.05 3.758 0 7.05-2.376 8.882-5.939 7.609 4.794 22.631 8.088 35.731 8.088 18.446 0 26.09-6.53 26.09-14.583 0-8.055-7.645-14.583-26.09-14.583z",
	        fill: "#FE9A35"
	      }),
	      _react2.default.createElement("path", {
	        d: "M16.08 49.981V50c0 4.34-1.863 8.16-4.687 10.384 1.644 1.295 3.612 2.05 5.73 2.05 3.758 0 7.05-2.376 8.882-5.938 7.609 4.793 22.631 8.087 35.731 8.087 18.446 0 26.09-6.529 26.09-14.583v-.019H16.08z",
	        fill: "#FF7C11"
	      }),
	      _react2.default.createElement("path", {
	        d: "M62.425 35.42A20.7 20.7 0 0 0 56.445 50a20.7 20.7 0 0 0 5.98 14.58c17.946-.162 25.4-6.627 25.4-14.58s-7.454-14.418-25.4-14.58z",
	        fill: "#F9C41E"
	      }),
	      _react2.default.createElement("path", {
	        d: "M56.445 49.981V50a20.7 20.7 0 0 0 5.98 14.58c17.946-.162 25.4-6.627 25.4-14.58v-.019h-31.38z",
	        fill: "#FE9A35"
	      }),
	      _react2.default.createElement("circle", { fill: "#4D4D4D", cx: 77.344, cy: 47.525, r: 2.148 })
	    )
	  );
	};
	
	exports.default = Fish;
	module.exports = exports["default"];

/***/ }),

/***/ 369:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = {
	  landingSectionTitle: 'Best Traditional Restaurant in Lastovo',
	  landingSectionSubtitle: 'Traditional cuisine enriched with organic and local produce.',
	  yachtDocking: 'Free Yacht Docking in Lastovo For Resturant Guests',
	  dockingParagraph: 'All Augusta Insula guests who visit Lastovo Island can use our dock free of charge. Docking includes standard marine equipment. Electricity and water supply may be subject to a fee. Be our guests and we’ll take care of the rest!',
	  readMore: 'Read more',
	  aboutCousine: 'Domestic food, own-grown vegetables, fresh fish',
	  cousineParagraph: 'Following the recipes of our ancestors and using organically grown produce, we passionately serve Lastovo’s best Mediterranean fish and meat dishes. We focus on unique culinary experience which can be uncovered only at the picturesque Zaklopatica bay of Lastovo.',
	  cousineCardTitle: 'Traditional barbecue "peka" dome',
	  cousineCardParagraph: '"Peka" is a traditional barbeque dish in Dalmatia. Fish or meat is carefully placed under a bell/dome and covered in hot charcoal for hours. This is the experience you will take home forever!',
	  veggieParagraph: 'Vegetables are freshly and organically grown in our family garden or purchased from small local farms.',
	  veggieKeywords: "Best sea restaurant Korcula",
	  familyText: 'Family run tavern brings together the very best secret flavours and savours of the Lastovo Island and Mediterranean sea.',
	  familyTextKeywords: 'Authentic Croatian cuisine',
	  restaurantSectionParagraph: 'Augusta insula is the most loved seafood restaurant on the Adriatic. Enjoy fresh food and complimentary docking for your ship',
	  restaurantSectionKeywords: 'Top seafood restaurant Lastovo',
	  // 'We are looking forward to welcoming everyone visiting Lastovo Island or sailing around  Dalmatian coast with an appetite for the best sea and meat specialities prepared by the Jurica family traditional recipes – served in unique surroundings among the national park Lastovo.',
	  specialities: 'Delicious Adriatic Specialities',
	  fishMenu: 'Fish menu',
	  specialitiesDescription: 'We highly recommend trying out a lobster from the depths of the Lastovo waters, prepared according to  traditional recipes. Other popular fish dishes include dentext, scorpion fish, scampi, and more. Our fish comes in fresh throughout the day.',
	  bookNow: 'Book now',
	  foodGallery: 'Food gallery',
	  wineTitle: 'Our Autochthonous Wine',
	  wineParagraph: 'Red wine Augusta Insula owes its special flavor and aroma to the island\'s distinctive vineyards. It is made from Plavac Mali, named for the small blue fruit the vines produce. Plavac Mali is an indigenous Dalmatian grape sort so this wine is warm, full and rich in taste. Plavac Mali is of dark ruby color, with a rich bouquet and specific aroma. Considering that this is a dry wine, it complements fried fish, risottos, meat and many other meals. White wine Augusta Insula is made from Maraština or Rukatac. Maraština (Rukatac) is of specific yellow to gold-yellow color, fine aroma, full and very harmonious taste. The light golden color and harmonious flavor of this wine perfectly illustrate the climate that gave birth to it. This high-quality white dry wine of a very pleasant aroma with full taste perfectly compliments seafood dishes and roast meats.'
	};
	module.exports = exports['default'];

/***/ }),

/***/ 381:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.imagesQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _restaurant = __webpack_require__(369);
	
	var _restaurant2 = _interopRequireDefault(_restaurant);
	
	var _i18n = __webpack_require__(13);
	
	var _Restaurant = __webpack_require__(157);
	
	var _Restaurant2 = _interopRequireDefault(_Restaurant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Restaurant = function Restaurant(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(_Restaurant2.default, { data: data, i18n: (0, _i18n.i18n)(_restaurant2.default) });
	};
	
	exports.default = Restaurant;
	var imagesQuery = exports.imagesQuery = '** extracted graphql fragment **';

/***/ }),

/***/ 157:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.restaurantImagesFragment = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyImage = __webpack_require__(7);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _gatsbyLink = __webpack_require__(21);
	
	var _reactHelmet = __webpack_require__(85);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _LandingSection = __webpack_require__(24);
	
	var _LandingSection2 = _interopRequireDefault(_LandingSection);
	
	var _Section = __webpack_require__(25);
	
	var _Section2 = _interopRequireDefault(_Section);
	
	var _Button = __webpack_require__(16);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Gallery = __webpack_require__(92);
	
	var _Gallery2 = _interopRequireDefault(_Gallery);
	
	var _DecoratedImage = __webpack_require__(90);
	
	var _DecoratedImage2 = _interopRequireDefault(_DecoratedImage);
	
	var _ImageWithCard = __webpack_require__(45);
	
	var _ImageWithCard2 = _interopRequireDefault(_ImageWithCard);
	
	var _specialities = __webpack_require__(233);
	
	var _specialities2 = _interopRequireDefault(_specialities);
	
	var _Chicken = __webpack_require__(121);
	
	var _Chicken2 = _interopRequireDefault(_Chicken);
	
	var _Fish = __webpack_require__(127);
	
	var _Fish2 = _interopRequireDefault(_Fish);
	
	var _Cupcake = __webpack_require__(125);
	
	var _Cupcake2 = _interopRequireDefault(_Cupcake);
	
	var _ContactForm = __webpack_require__(23);
	
	var _ContactForm2 = _interopRequireDefault(_ContactForm);
	
	var _images = __webpack_require__(29);
	
	var _Reviews = __webpack_require__(94);
	
	var _Reviews2 = _interopRequireDefault(_Reviews);
	
	var _stylesModule = __webpack_require__(202);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Restaurant = function Restaurant(_ref) {
	  var data = _ref.data,
	      i18n = _ref.i18n;
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: i18n('landingSectionTitle') + ' - Augusta Insula',
	      meta: [{ name: 'description', content: i18n('landingSectionSubtitle') }, {
	        name: 'keywords',
	        content: 'lastovo restaurant, traditional food in lastovo, best placecs to eat at in Lastovo, fish restaurant, fresh food Lastovo, barbecue, barbeque, lastovo cuisine, zaklopatica, Korcula restaurant, best restaurant Korcula'
	      }],
	      script: [{
	        type: 'application/ld+json',
	        innerHTML: '{\n          "@context": "http://schema.org",\n          "@graph": [\n            {\n              "@context": "http://schema.org",\n              "@type": "Restaurant",\n              "image": [\n                "https://augustainsula.com' + data.restaurantImage.sizes.src + '",\n                "https://augustainsula.com' + data.cousineImage.sizes.src + '",\n                "https://augustainsula.com' + data.desertImage.sizes.src + '",\n                "https://augustainsula.com' + data.veggiesImage.sizes.src + '"\n              ],\n              "@id": "https://augustainsula.com/en/restaurant",\n              "name": "Augusta Insula Lastovo Restaurant",\n              "url": "https://augustainsula.com/en/restaurant",\n              "openingHoursSpecification": [\n                {\n                  "@type": "OpeningHoursSpecification",\n                  "dayOfWeek": [\n                    "Monday",\n                    "Tuesday",\n                    "Wednesday",\n                    "Thursday",\n                    "Friday",\n                    "Saturday",\n                    "Sunday"\n                  ],\n                  "opens": "09:00",\n                  "closes": "23:59"\n                }\n              ],\n              "address": {\n                "@type": "PostalAddress",\n                "streetAddress": "Zaklopatica 21",\n                "addressLocality": "Lastovo",\n                "addressRegion": "Croatia",\n                "telephone": "+385-98-571-884",\n                "email": "info@augustainsula.com"\n              },\n              "menu": "https://augustainsula.com/en/restaurant",\n              "acceptsReservations": true,\n              "priceRange": "$$$",\n              "servesCuisine": "Dalmatian, Fish, Meat, Vegan, Mediterranean, Organic, Italian, Traditional",\n              "paymentAccepted": "Cash, Credit Cards",\n              "email": "info@augustainsula.com",\n              "aggregateRating": {\n                "@type": "AggregateRating",\n                "ratingValue": "96",\n                "bestRating": "100",\n                "worstRating": "1",\n                "ratingCount": "173"\n              },\n              "review": {\n                "@type": "Review",\n                "url": "https://www.tripadvisor.com/ShowUserReviews-g2039687-d2206293-r505567529-Konoba_Augusta_Insula-Zaklopatica_Lastovo_Island_Dubrovnik_Neretva_County_Dalma.html",\n                "author": {\n                  "@type": "Person",\n                  "name": "Grguru",\n                  "sameAs": "https://www.tripadvisor.com/members/Grguru"\n                },\n                "publisher": {\n                  "@type": "Organization",\n                  "name": "TripAdvisor",\n                  "sameAs": "https://www.tripadvisor.com"\n                },\n                "datePublished": "2018-07-25T20:00",\n                "description": "We wanted to impress our friends and the skipper recommended Augusta Insula. They have their own dock with water and electricity which was a huge bonus for us. The dock fits about 7-8 ships, and we were in two catamarans. It was nice that we could dock together. The food was nothing short of fantastic. The appetizer included Dentex Carpaccio, a tasty home speciality zucchini pie and octopus salad. The main course was lobster and fish from Peka, with a home made cake for desert. The veggies are locally harvested and fish is freshly caught. It was so incredibly delicious. Our friends have seen the world and they all said this was their best eating experience ever. This mean the world to us and we truly appreciate the hospitality at Augusta Insula.  If you want to enjoy absolutely the best eating experience with the most amazing food and friendliest hosts, Augusta Insula is the place to go! Can\'t wait to go again!",\n                "inLanguage": "en",\n                "reviewRating": {\n                  "@type": "Rating",\n                  "worstRating": 1,\n                  "bestRating": 5,\n                  "ratingValue": 5\n                }\n              }\n            }\n          ]\n        }'
	      }]
	    }),
	    _react2.default.createElement(_LandingSection2.default, {
	      title: i18n('landingSectionTitle'),
	      subtitle: i18n('landingSectionSubtitle'),
	      image: data.landingImage
	    }),
	    _react2.default.createElement(
	      _Section2.default,
	      { className: _stylesModule2.default.docking },
	      _react2.default.createElement(_DecoratedImage2.default, { img: data.yachtImage, className: _stylesModule2.default.dockingImage }),
	      _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.dockingContent },
	        _react2.default.createElement(
	          'h3',
	          { className: _stylesModule2.default.dockingTitle },
	          i18n('yachtDocking')
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          i18n('dockingParagraph')
	        ),
	        _react2.default.createElement(
	          _Button2.default,
	          { className: _stylesModule2.default.button, onClick: function onClick() {
	              return (0, _gatsbyLink.navigateTo)('./docking');
	            } },
	          i18n('readMore')
	        )
	      )
	    ),
	    _react2.default.createElement(_Section2.default, {
	      background: data.veggiesImage,
	      text: i18n('veggieParagraph'),
	      alt: i18n('veggieKeywords')
	    }),
	    _react2.default.createElement(
	      _Section2.default,
	      { className: _stylesModule2.default.cousine },
	      _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.cousineHeader },
	        _react2.default.createElement(
	          'h2',
	          null,
	          i18n('aboutCousine')
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          i18n('cousineParagraph')
	        )
	      )
	    ),
	    _react2.default.createElement(_Section2.default, {
	      background: data.familyImage,
	      text: i18n('familyText'),
	      alt: i18n('familyTextKeywords')
	    }),
	    _react2.default.createElement(
	      _Section2.default,
	      { className: _stylesModule2.default.docking },
	      _react2.default.createElement(_DecoratedImage2.default, { img: data.wineImage, className: _stylesModule2.default.dockingImage }),
	      _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.dockingContent },
	        _react2.default.createElement(
	          'h3',
	          { className: _stylesModule2.default.dockingTitle },
	          i18n('wineTitle')
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          i18n('wineParagraph')
	        )
	      )
	    ),
	    _react2.default.createElement(_Section2.default, {
	      background: data.restaurantImage,
	      text: i18n('restaurantSectionParagraph'),
	      alt: i18n('restaurantSectionKeywords')
	    }),
	    _react2.default.createElement(
	      _Section2.default,
	      { className: _stylesModule2.default.specialitiesSection },
	      _react2.default.createElement(
	        'h1',
	        { className: _stylesModule2.default.title },
	        i18n('specialities')
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _stylesModule2.default.specialities },
	        _react2.default.createElement(_gatsbyImage2.default, {
	          sizes: data.specialitiesImage.sizes,
	          className: _stylesModule2.default.specialitiesImg
	        }),
	        _react2.default.createElement(
	          'div',
	          { className: _stylesModule2.default.specialitiesCard },
	          _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.icons },
	            _react2.default.createElement(_Chicken2.default, { className: _stylesModule2.default.icon }),
	            _react2.default.createElement(_Fish2.default, { className: _stylesModule2.default.icon }),
	            _react2.default.createElement(_Cupcake2.default, { className: _stylesModule2.default.icon })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: _stylesModule2.default.menuOptions },
	            _react2.default.createElement(
	              'h3',
	              { className: _stylesModule2.default.optionTitle },
	              i18n('fishMenu')
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              i18n('specialitiesDescription')
	            ),
	            _react2.default.createElement(
	              _Button2.default,
	              { className: _stylesModule2.default.button, anchor: 'contact-form' },
	              i18n('bookNow')
	            )
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Section2.default,
	      null,
	      _react2.default.createElement(
	        'h2',
	        null,
	        i18n('foodGallery')
	      ),
	      _react2.default.createElement(_Gallery2.default, { images: (0, _images.flattenImages)(data.galleryImages) })
	    ),
	    _react2.default.createElement(_Reviews2.default, { title: 'Reviews', image: data.testimonialsImage }),
	    _react2.default.createElement(
	      _Section2.default,
	      { className: _stylesModule2.default.cousine },
	      _react2.default.createElement(_ImageWithCard2.default, {
	        className: _stylesModule2.default.cousineCard,
	        content: _react2.default.createElement(
	          'div',
	          { className: _stylesModule2.default.cousineContent },
	          _react2.default.createElement(
	            'h3',
	            { className: _stylesModule2.default.cardTitle },
	            i18n('cousineCardTitle')
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            i18n('cousineCardParagraph')
	          )
	        ),
	        image: data.cousineImage
	      })
	    ),
	    _react2.default.createElement(_ContactForm2.default, { image: data.contactFormImage })
	  );
	};
	
	exports.default = Restaurant;
	var restaurantImagesFragment = exports.restaurantImagesFragment = '** extracted graphql fragment **';

/***/ }),

/***/ 202:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"headerTitle":"src-templates-Restaurant----styles-module---headerTitle---3-9bz","subtitle":"src-templates-Restaurant----styles-module---subtitle---2Dh_d","docking":"src-templates-Restaurant----styles-module---docking---3yYk3","dockingContent":"src-templates-Restaurant----styles-module---dockingContent---6XTuN","dockingImage":"src-templates-Restaurant----styles-module---dockingImage---1g-0y","dockingTitle":"src-templates-Restaurant----styles-module---dockingTitle---1G2-r","desertImage":"src-templates-Restaurant----styles-module---desertImage---29x_t","desertImageWrapper":"src-templates-Restaurant----styles-module---desertImageWrapper---3BIuw","desertImageSection":"src-templates-Restaurant----styles-module---desertImageSection---1mAx8","button":"src-templates-Restaurant----styles-module---button---1yqDv","cousine":"src-templates-Restaurant----styles-module---cousine---ASsJy","cousineHeader":"src-templates-Restaurant----styles-module---cousineHeader---2aEGW","cousineContent":"src-templates-Restaurant----styles-module---cousineContent---YiISt","cousineCard":"src-templates-Restaurant----styles-module---cousineCard---zG_m7","title":"src-templates-Restaurant----styles-module---title---1la9B","cardTitle":"src-templates-Restaurant----styles-module---cardTitle---3q2H6","restaurantImageTitle":"src-templates-Restaurant----styles-module---restaurantImageTitle---kV3Rs","optionTitle":"src-templates-Restaurant----styles-module---optionTitle---1HRcF","specialities":"src-templates-Restaurant----styles-module---specialities---ZbeFP","specialitiesSection":"src-templates-Restaurant----styles-module---specialitiesSection---1Yl0I","specialitiesImg":"src-templates-Restaurant----styles-module---specialitiesImg---3Mx9X","specialitiesCard":"src-templates-Restaurant----styles-module---specialitiesCard---2oLLS","icons":"src-templates-Restaurant----styles-module---icons---196S1","icon":"src-templates-Restaurant----styles-module---icon---3qR5j","menuOptions":"src-templates-Restaurant----styles-module---menuOptions---3nvSX","restaurantSection":"src-templates-Restaurant----styles-module---restaurantSection---26Tui","menuOptios":"src-templates-Restaurant----styles-module---menuOptios---eDrPQ"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-en-restaurant-index-js-36cd2f015a503872a6a0.js